export const space = {
  11: '2.75rem',
  13: '3.25rem',
  15: '3.75rem',
};
